import { classDuration, timeSlotInterval } from "constants/variables";
import { getHours, getMinutes, naturalCompare } from "utilities";

// useId=true uses item.id as the option value (levels — matched against levelsId)
// useId=false uses color-or-name (styles/teachers — matched against stored name arrays)
const getOptions = (data, entity, useId = false) => {
  return data
    .map((item) => ({
      value: useId ? item.id : (item.color || item[`${entity}Name`]),
      label: item[`${entity}Name`],
      entity: entity,
      id: item.id
    }))
    .sort((a, b) => naturalCompare(a.label, b.label))
}
  
const getLengthOptions = () => {
  const lengthOptions = [];
  for (let i = classDuration.min.minutesInterval_5; i < classDuration.max; i += timeSlotInterval.minutes_5) {
    const label = getTime(i);
    lengthOptions.push({ value: getHours(i), label, entity: 'length' });
  }

  return lengthOptions;
}

const getTime = (value) => {
  const hour = Math.floor(getHours(value));
  const minutes = Math.round(value % 60);
  const minutesText = minutes > 0 ? minutes === 5 ? `0${minutes} m` : `${minutes} m` : '';
  return (hour > 0 ? `${hour} h ` : '') + minutesText;
}
  
const getDuration = (value) => {
  const hour = Math.floor(value);
  const minutes = getMinutes(value - hour);
  return `0${hour > 0 ? `${hour}` : '0'}:${minutes > 0 ? `${minutes}` : '00'}`
}

// Decide whether one class card survives the active sidebar filters.
//
// AND across filter categories, OR within a category.
//
// Levels are resolved from `levelsId` to a level NAME via the allLevels lookup and
// compared against the option label. Matching on the id alone breaks whenever the ids
// arrive as strings on one side and numbers on the other, and matching on colour breaks
// whenever two levels share a colour. Number() on both sides of the lookup removes the
// first problem; using the name removes the second.
// Styles and teachers keep matching by their stored name arrays.
const matchesFilters = (item, filters, allLevels = []) => {
  return Object.keys(filters).every((key) => {
    if (!filters[key] || filters[key].length === 0) return true;

    if (key === 'length') {
      return filters[key].some(el => el.value === item[key]);
    }

    if (key === 'levels') {
      const levelNames = (item.levelsId || [])
        .map(id => allLevels.find(l => Number(l.id) === Number(id))?.levelName)
        .filter(Boolean);
      if (levelNames.length === 0) return false;
      return levelNames.some(name => filters.levels.some(f => f.label === name));
    }

    const itemValues = item[key];
    if (Array.isArray(itemValues) && itemValues.length > 0) {
      return itemValues.some(element => filters[key].some(el => el.value === element));
    }
    return false;
  });
};

export {
  getOptions,
  getLengthOptions,
  getTime,
  getDuration,
  matchesFilters
}